export const Breakpoints: {
  xs: string
  sm: string
  md: string
  lg: string
  xl: string
  xxl: string
} = {
  xs: '320px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
}

export const BreakpointsMediaQueries: {
  xs: string
  sm: string
  md: string
  lg: string
  xl: string
  xxl: string
} = {
  xs: `(max-width: ${Breakpoints.xs})`,
  sm: `(max-width: ${Breakpoints.sm})`,
  md: `(max-width: ${Breakpoints.md})`,
  lg: `(max-width: ${Breakpoints.lg})`,
  xl: `(max-width: ${Breakpoints.xl})`,
  xxl: `(max-width: ${Breakpoints.xxl})`,
}
